<template>
    <div class="main-panel">
        <h1>New Orders</h1>
    </div>
</template>